import {
  ArrowLeftOutlined,
  LeftOutlined,
  RightOutlined,
} from "@ant-design/icons";
import { Button, Card, DatePicker, Flex, Space, Typography } from "antd";
import type { Dayjs } from "dayjs";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import ModalAddMeetingSchedule from "../../components/modal/hrm/ModalAddMeetingSchedule";
import { IMeetingSchedule } from "../../models/Hrm";
import { useGetMyMeetingSchedule } from "../../query/HrmQuery";
import WeeklyMeetingGrid from "../../components/hrm/WeeklyMeetingGrid";
const { Text } = Typography;

const getStartOfWeek = (date: Dayjs) => {
  const day = date.day();
  const diff = day === 0 ? -6 : 1 - day;
  return date.add(diff, "day").startOf("day");
};

const PersonalMeetingSchedule = () => {
  const navigate = useNavigate();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentWeekStart, setCurrentWeekStart] = useState<Dayjs>(
    getStartOfWeek(dayjs()),
  );
  const [selectedDate, setSelectedDate] = useState<Dayjs | undefined>(
    undefined,
  );

  const [time, setTime] = useState<Date>(currentWeekStart.toDate());

  useEffect(() => {
    setTime(currentWeekStart.toDate());
  }, [currentWeekStart]);

  const { data: schedulesData } = useGetMyMeetingSchedule(time.toISOString());

  const schedules = schedulesData || [];

  const getListData = (value: Dayjs) => {
    return schedules.filter((schedule: IMeetingSchedule) =>
      dayjs(schedule.startTime).isSame(value, "day"),
    );
  };

  const weekStartMonth = currentWeekStart.format("MM/YYYY");
  const weekEndMonth = currentWeekStart.add(6, "day").format("MM/YYYY");
  const monthDisplay =
    weekStartMonth === weekEndMonth
      ? `Tháng ${weekStartMonth}`
      : `Tháng ${weekStartMonth} - ${weekEndMonth}`;

  return (
    <Flex vertical gap="middle" className="p-4 w-full overflow-hidden">
      <Space>
        <Button
          type="default"
          size="large"
          icon={<ArrowLeftOutlined />}
          onClick={() => navigate(-1)}
          className=" bg-white dark:bg-gray-700 text-gray-800 dark:text-white border-gray-300 dark:border-gray-600 hover:bg-gray-50 dark:hover:bg-gray-600"
        >
          Quay lại
        </Button>
      </Space>
      <Card
        className="w-full overflow-hidden"
        styles={{ body: { padding: 16, overflowX: "auto" } }}
        title={
          <Flex justify="space-between" align="center" wrap="wrap" gap={8}>
            <Text strong className="text-base md:text-lg">
              Lịch họp theo tuần - {monthDisplay} ({schedules.length})
            </Text>
            <Space wrap>
              <DatePicker
                picker="week"
                value={currentWeekStart}
                allowClear={false}
                placeholder="Chọn tuần"
                onChange={(date) => {
                  if (date) setCurrentWeekStart(getStartOfWeek(date));
                }}
              />
              <Flex gap={5}>
                <Button
                  icon={<LeftOutlined />}
                  onClick={() =>
                    setCurrentWeekStart((prev) => prev.subtract(1, "week"))
                  }
                />
                <Button
                  onClick={() => setCurrentWeekStart(getStartOfWeek(dayjs()))}
                >
                  Tuần này
                </Button>
                <Button
                  icon={<RightOutlined />}
                  onClick={() =>
                    setCurrentWeekStart((prev) => prev.add(1, "week"))
                  }
                />
              </Flex>
            </Space>
          </Flex>
        }
      >
        <WeeklyMeetingGrid
          currentWeekStart={currentWeekStart}
          getListData={getListData}
          setSelectedDate={setSelectedDate}
          setIsModalOpen={setIsModalOpen}
        />
      </Card>

      <ModalAddMeetingSchedule
        open={isModalOpen}
        onCancel={() => setIsModalOpen(false)}
        onSuccess={() => setIsModalOpen(false)}
        initialDate={selectedDate}
      />
    </Flex>
  );
};

export default PersonalMeetingSchedule;
